
import { props, emptyProps, createAction } from '@ngrx/store';
import { LoginPayload } from 'libs/models/src/lib/user';

export const LOGIN = createAction(
  'LOGIN',
  props<{loginInput:any}>()
);

export const LOGIN_WITH_GOOGLE = createAction(
  'LOGIN_WITH_GOOGLE',
  props<{loginInput:LoginPayload}>()
);
export const LOGIN_SUCCESS = createAction(
  'LOGIN_SUCCESS',
  props<{user:any,token:string,redirect:boolean,auth_response:any}>()
);
export const LOGIN_FAILED = createAction(
  'LOGIN_FAILED',
  props<{error:any}>()
);







export const AUTO_LOGIN = createAction(
  'AUTO_LOGIN',
  emptyProps
);


// TESTING code ...


export const STATSIG_INITIALIZE  = createAction(
  'STATSIG_INITIALIZE',
  emptyProps
);


// for unauthorized ... // TODO ..
export const STATSIG_UPDATE_USER  = createAction(
  'STATSIG_UPDATE_USER',
  props<{selected_tenant:any}>()
);

export const STATSIG_UPDATE_USER_SUCCESS  = createAction(
  'STATSIG_UPDATE_USER_SUCCESS',
  props<{user:any}>()
);

export const SET_USER_THEME  = createAction(
  'SET_USER_THEME',
  emptyProps
);


